import { Box, Icon, ScrollPane, Text } from '@nimbus-ds/components';
import { ExternalLinkIcon } from '@nimbus-ds/icons';
import type { HelpLink } from '@tiendanube/common';

export interface ChatHelpLinksProps {
  helpLinks: HelpLink[];
}

/**
 * Renders help links at the bottom of AI messages as small tag-like buttons
 */
export function ChatHelpLinks({
  helpLinks,
}: Readonly<ChatHelpLinksProps>): JSX.Element {
  return (
    <ScrollPane
      showGradients
      showArrows
      showScrollbar={false}
      contentContainerProps={{ gap: '1', margin: 'none' }}
    >
      {helpLinks.map((link) => (
        <ScrollPane.Item key={link.url}>
          <Box
            as="a"
            rel="noopener noreferrer"
            aria-label={`Open ${link.title} in a new tab`}
            href={link.url}
            target="_blank"
            textDecoration="none"
            display="flex"
            flexWrap="nowrap"
            gap="2"
            alignItems="center"
            backgroundColor={{
              xs: 'neutral-background',
              hover: 'neutral-surface',
              active: 'neutral-surfaceHighlight',
            }}
            borderColor="neutral-surfaceHighlight"
            borderStyle="solid"
            borderWidth="1"
            borderRadius="2"
            px="2"
            py="1"
            minWidth="100px"
            maxWidth="134px"
          >
            <Text
              fontSize="caption"
              color="neutral-textHigh"
              lineHeight="caption"
              wordBreak="break-all"
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
            >
              {link.title}
            </Text>
            <Icon
              source={<ExternalLinkIcon size="small" />}
              color="neutral-textHigh"
            />
          </Box>
        </ScrollPane.Item>
      ))}
    </ScrollPane>
  );
}

export default ChatHelpLinks;
